var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F3B41B;}\n\t.st1{fill:#F7D04A;}\n\t.st2{fill:#666666;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.3,451.9L242,73.9c5.9-11.4,22.2-11.4,28,0l193.7,378c5.4,10.5-2.2,22.9-14,22.9H62.3 C50.5,474.8,42.9,462.4,48.3,451.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M508.5,495c-4.3,7.1-11.9,11.3-20.1,11.3H23.6c-8.3,0-15.8-4.2-20.1-11.3c-4.3-7.1-4.6-15.7-0.9-23.1L235,18.5 c4.1-7.9,12.1-12.8,21-12.8s17,4.9,21,12.8l232.4,453.4C513.2,479.3,512.8,487.9,508.5,495z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.1,447.6L249,94.7c2.9-5.7,11.1-5.7,14,0l180.9,352.9c2.7,5.2-1.1,11.5-7,11.5H75.1 C69.3,459.1,65.4,452.9,68.1,447.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.5,495c-4.3,7.1-11.9,11.3-20.1,11.3H23.6c-8.3,0-15.8-4.2-20.1-11.3c-4.3-7.1-4.6-15.7-0.9-23.1L235,18.5 c4.1-7.9,12.1-12.8,21-12.8s17,4.9,21,12.8l232.4,453.4C513.2,479.3,512.8,487.9,508.5,495z M62.3,474.8h387.5 c11.8,0,19.4-12.4,14-22.9L270,73.9c-5.9-11.4-22.2-11.4-28,0l-193.7,378C42.9,462.4,50.5,474.8,62.3,474.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "301.5,135.4 336.9,135.4 311.1,85 275.7,85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "236.3,85 200.9,85 175.1,135.4 210.5,135.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "183.6,187.9 148.2,187.9 122.4,238.2 157.8,238.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "354.2,238.2 389.6,238.2 363.8,187.9 328.4,187.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "406.9,341 442.3,341 416.5,290.7 381.1,290.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "130.9,290.7 95.5,290.7 69.7,341 105.1,341  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "78.2,393.5 42.8,393.5 17,443.9 52.4,443.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "459.6,443.9 495,443.9 469.2,393.5 433.8,393.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "461.4,447.3 464.8,443.9 459.6,443.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "374.5,474.8 343,506.3 402.3,506.3 433.8,474.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "229.7,474.8 198.2,506.3 257.5,506.3 289,474.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "84.9,474.8 53.4,506.3 112.7,506.3 144.2,474.8  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256.2,397.6c0-15.2-37-41.9-48.1-56.6c-33.4-43.8-5.6-88.8-5.6-88.8c-65.2,49.2-37,113.3-37,113.3 c28.6,62.4,80.3,64.5,90.7,64.4c10.4,0.2,62.1-1.9,90.7-64.4c0,0,28.2-64.2-37-113.3c0,0,27.7,45-5.6,88.8 C293.2,355.7,256.2,382.6,256.2,397.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M286.6,287.4c0,16.4-13.6,29.9-30.3,29.9c-16.7,0-30.3-13.5-30.3-29.9c0-16.6,13.6-29.9,30.3-29.9 S286.6,271,286.6,287.4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSign);
export default __webpack_public_path__ + "static/media/error_sign.b3693a86dad3d2bff53c8a147da5bb1e.svg";
export { ForwardRef as ReactComponent };